"use strict";

import React from 'react';
import defaultState from '../store/account-initial-state';
import { AccountProvider as Provider } from "../context/AccountContext";
import axios from "../utilities/axiosEcheckWrapper";
import objectPath from 'object-path';
import deepEqual from 'deep-equal';
import {withAlert} from "react-alert";
import {withRouter} from "react-router-dom";
import emailExists from "../../emailExists";
import formatPhoneNumber from "../../formatPhoneNumber";

class AccountProvider extends React.Component {

    constructor(props) {
        super(props);
        this.state = defaultState;
        this.fetchAccount = this.fetchAccount.bind(this);
        this.setAccount = this.setAccount.bind(this);
        this.updateAccountAddress = this.updateAccountAddress.bind(this);
        this.emailIsUnique = this.emailIsUnique.bind(this);
        this.updateAccountEmail = this.updateAccountEmail.bind(this);
        this.updateAccountPassword = this.updateAccountPassword.bind(this);
        this.redirectToAccountSettings = this.redirectToAccountSettings.bind(this);
    }

    componentDidMount() {}

    fetchAccount(){
        this.setState(()=>{return {isFetchingAccount: true,};});
        axios.get(`echecks/accounts`)
            .then((response)=>{
                this.setAccount(response.data);
            })
            .catch((error)=>{
                return false;
            }).finally(()=>{
                this.setState(()=>{return {isFetchingAccount: false,};});
        });
    }

    setAccount(account={}){
        this.setState(()=>{
            const updatedAccount = {...account};
            const address = {...objectPath.get(updatedAccount, 'billing_address', {})};
            //address.phone = formatPhoneNumber( address.phone || '' );
            return {
                id: updatedAccount.customer_id || 0,
                account: updatedAccount,
                address: address,
            };
        }, ()=>{
            //
        })
    }

    updateAccountAddress(id=0, data={}){
        const [zip = '', zip5 = '', zip4 = ''] = data.zip.match(/^(\d{5})-?(\d{4})?$/);
        const phone = data.phone.replace(/[^\d]/g, '');
        const updatedData = {...data, ...{zip5, zip4, phone}};
        delete updatedData.zip;
        const {address} = this.state;
        const updatedFullAddress = {...address, ...updatedData};

        if (deepEqual( updatedFullAddress, address ))
            this.redirectToAccountSettings();
        if (id && !!updatedData) {
            this.setState(()=>{return {isUpdatingAddress: true,};});
            axios.put(`echecks/accounts/addresses/${id}`, updatedFullAddress)
                    .then((response) => {
                        this.fetchAccount();
                        this.props.alert.success('Your contact information has been updated', {
                            onOpen: () => {
                                this.redirectToAccountSettings();
                            },
                        });
                    })
                    .catch((error) => {
                        this.props.alert.error(`Sorry, an error occurred. ${error.message || ''}`);
                    }).finally(()=>{
                    this.setState(()=>{return {isUpdatingAddress: false,};});
            });
            }
    }

    redirectToAccountSettings(){
        this.props.history.push('/echeck/accounts/settings/');
    }

    emailIsUnique(email=''){
        return new Promise((resolve, reject) => {
            if (!!email) {
                this.setState(()=>{return {isFindingEmail: true,};});
                emailExists(email).then((response) => {
                    reject(0);
                }).catch((error) => {
                    resolve(1);
                }).finally(()=>{
                    this.setState(()=>{return {isFindingEmail: false,};});
                });
            }
        });
    }

    updateAccountEmail(email=''){
        const {account} = this.state;
        if (!!email) {
            if (deepEqual(email, account.email))
                return email;
            this.setState(()=>{return {isUpdatingEmail: true,};});
            axios.put(`echecks/accounts/emails`, {email: email,})
                .then((response) => {
                    this.fetchAccount();
                    this.props.alert.success('Your e-mail address has been updated');
                })
                .catch((error) => {
                    let errorMessage = `Sorry, an error occurred. ${error.data.message || ''} `;
                    if(!!error && !!error.data && !!error.data.errors) {
                        Object.keys(error.data.errors).forEach(key =>{
                            error.data.errors[key].forEach((message)=>{errorMessage += ` ${message}`;});
                        });
                    }
                    this.props.alert.error(errorMessage);
                }).finally(()=>{
                this.setState(()=>{return {isUpdatingEmail: false,};});
            });
        }
    }

    updateAccountPassword(data= {}){
        return new Promise((resolve, reject) => {
            if (!!data) {
                this.setState(()=>{return {isUpdatingPassword: true,};});
                axios.put(`echecks/accounts/passwords`, data)
                    .then((response) => {
                        this.props.alert.success('Your password has been updated');
                        resolve();
                    })
                    .catch((error) => {
                        this.props.alert.error(`Sorry, an error occurred. ${error.data.message || ''}`);
                        reject();
                    })
                    .finally(()=>{
                        this.setState(()=>{return {isUpdatingPassword: false,};});
                });
            }
        });
    }

    render() {
        return (
            <Provider value={{
                ...this.state,
                fetchAccount: this.fetchAccount,
                emailIsUnique: this.emailIsUnique,
                updateAccountAddress: this.updateAccountAddress,
                updateAccountEmail: this.updateAccountEmail,
                updateAccountPassword: this.updateAccountPassword,
            }}> {this.props.children}</Provider>);
    }
}

export default withAlert()(withRouter(AccountProvider));
